/**
 * /fields → the home list (/).
 *
 * /fields was a second list of the same fields as home, behind a screen of
 * buttons and chips (audit step 4, M2, George 16/10/2026). Home now carries
 * what it added: the grower filter and the add-field wizard. The old links
 * keep working: /fields?owner=30 (Διαχείριση Χρηστών, «Χωράφια» of a grower)
 * opens home on that grower's fields, /fields?create=true opens the wizard.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const fieldsTarget = (search) => {
  const from = new URLSearchParams(search);
  const to = new URLSearchParams();
  if (from.get('owner')) to.set('owner', from.get('owner'));
  if (from.get('create') === 'true') to.set('action', 'create-field');
  const qs = to.toString();
  return qs ? `/?${qs}` : '/';
};

export const FieldsRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={fieldsTarget(search)} replace />;
};

export default FieldsRedirect;
